import React from 'react';
import PropTypes from 'prop-types';

import { ButtonGroupContainer, StyledButton } from './ButtonGroup.styles';

const ButtonGroup = ({ buttons, onClick, selectedValue, className, ...restProps }) => (
  <ButtonGroupContainer className={className} {...restProps}>
    {buttons.map((button) => (
      <StyledButton
        key={button.value}
        type="button"
        onClick={() => onClick && onClick(button.value)}
        selected={button.value === selectedValue}
      >
        {button.label}
      </StyledButton>
    ))}
  </ButtonGroupContainer>
);

ButtonGroup.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.node
    })
  ).isRequired,
  onClick: PropTypes.func.isRequired,
  selectedValue: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default ButtonGroup;
